import React from "react";
import { Link } from "react-router";
import classNames from "classnames";

interface Props {
  body: string | number | boolean | object | string[] | number[] | object[];
  extraClasses?: string;
  id?: string;
  showLabel?: boolean;
  label?: string;
  showSubLabel?: boolean;
  hyperLink?: string;
  hyperLinkText?: string;
}

interface BodyProps {
  body: string | number | boolean | object | string[] | number[] | object[];
  hyperLink?: string;
  hyperLinkText?: string;
}

const Body = (props: BodyProps): JSX.Element => {
  const { body, hyperLink = "", hyperLinkText } = props;

  // If it's an external link, use the <a> tag, otherwise it's an internal link and use the Link component
  if (hyperLink?.includes("http")) {
    if (hyperLinkText) {
      return <a href={hyperLink}>{hyperLinkText}</a>;
    } else {
      return <a href={hyperLink}>{hyperLink}</a>;
    }
  } else if (hyperLink) {
    if (hyperLinkText) {
      return <Link to={hyperLink}>{hyperLinkText}</Link>;
    } else {
      return <Link to={hyperLink}>{hyperLink}</Link>;
    }
  }

  return <>{body}</>;
};

const ReadOnlyContainer: React.FC<Props> = (props: Props): JSX.Element => {
  const { body, extraClasses, id, showLabel = false, label, showSubLabel, hyperLink, hyperLinkText } = props;

  const rootClasses = classNames(
    "caprx-f-elem-root caprx-f-elem-read-only-wrapper",
    { "caprx-f-elem-animate": showLabel },
    { "caprx-f-elem-read-only-no-value": showSubLabel && body === "N/A" },
    { "caprx-f-elem-read-only-with-sub-label": showLabel && showSubLabel && body !== "N/A" },
  );

  const containerClasses = classNames("caprx-f-elem-input caprx-f-elem-read-only", extraClasses);

  return (
    <div className={rootClasses}>
      <div className={containerClasses}>
        <Body hyperLink={hyperLink} hyperLinkText={hyperLinkText} body={body} />

        {showLabel && (
          <label htmlFor={id} className="caprx-f-elem-label">
            {label}
          </label>
        )}
      </div>
    </div>
  );
};

export default ReadOnlyContainer;
